require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/assign.js
// module id = ./node_modules/core-js/library/fn/object/assign.js
// module chunks = 11056403903869698000